module.exports = __webpack_public_path__ + "my.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/my.svg
// module id = 717
// module chunks = 0